import { useEffect } from "react";

const SITE_URL = "https://mehedihassain.in";

const setTag = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setTag('meta[property="og:title"]', "content", title);
    }
    if (description) {
      setTag('meta[name="description"]', "content", description);
    }
    const canonical = `${SITE_URL}${path}`;
    setTag('link[rel="canonical"]', "href", canonical);
    setTag('meta[property="og:url"]', "content", canonical);
  }, [title, description, path]);
  return null;
};

export default Seo;
